(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bl2-collection-shop"] && !Shopify.designMode) return;
  try {
    
(function(){document.addEventListener('change',function(e){if(e.target.matches('[data-bl-sort]'))e.target.form.submit()});document.addEventListener('click',function(e){const b=e.target.closest('.bl-shop-mobile-filter');if(!b)return;const panel=document.getElementById(b.getAttribute('aria-controls'));const open=!panel.classList.contains('is-open');panel.classList.toggle('is-open',open);b.setAttribute('aria-expanded',String(open))})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl2-deals"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-bld2-play]');
    if(!b)return;
    var row=b.closest('.bld2-track');
    var audio=row&&row.querySelector('audio');
    if(!audio)return;
    document.querySelectorAll('.bld2-track audio').forEach(function(a){
      if(a!==audio){a.pause();a.currentTime=a.currentTime;}
    });
    document.querySelectorAll('[data-bld2-play]').forEach(function(x){if(x!==b)x.textContent='▶'});
    document.querySelectorAll('.bld2-track').forEach(function(x){if(x!==row)x.classList.remove('is-active')});
    if(audio.paused){
      audio.play().then(function(){b.textContent='Ⅱ';row.classList.add('is-active')}).catch(function(){});
    }else{
      audio.pause();b.textContent='▶';row.classList.remove('is-active');
    }
  });
  document.addEventListener('ended',function(e){
    if(!e.target.matches('.bld2-track audio'))return;
    var row=e.target.closest('.bld2-track');
    if(row){row.classList.remove('is-active');var b=row.querySelector('[data-bld2-play]');if(b)b.textContent='▶';}
  },true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl2-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',e=>{document.querySelectorAll('.bl-mobile-menu[open]').forEach(menu=>{if(!menu.contains(e.target)||e.target.closest('a'))menu.open=false})});
document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.bl-mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus()})});
if(!window.bl2AudioBound){window.bl2AudioBound=true;document.addEventListener('click',function(e){const b=e.target.closest('[data-bl-play]');if(!b)return;const group=b.closest('[data-bl-audio]');const a=group.querySelector('audio');if(!a)return;if(a.paused){document.querySelectorAll('[data-bl-audio] audio').forEach(x=>{if(x!==a)x.pause()});a.play().catch(()=>{})}else a.pause()});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl2-producer-directory"]) return;
  try {
    
(function(){
  var input=document.querySelector('[data-producer-search]');
  var cards=[].slice.call(document.querySelectorAll('[data-producer-card]'));
  var count=document.querySelector('[data-producer-count]');
  if(!input)return;
  function update(){
    var q=input.value.trim().toLowerCase();
    var shown=0;
    cards.forEach(function(card){
      var match=!q||card.dataset.producerName.indexOf(q)!==-1;
      card.hidden=!match;
      if(match)shown++;
    });
    if(count)count.textContent=shown+' producers';
  }
  input.addEventListener('input',update);
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl2-producer-hub"]) return;
  try {
    
document.addEventListener('input',e=>{if(!e.target.matches('[data-bl-producer-search]'))return;const scope=e.target.closest('.bl-producer-directory');const q=e.target.value.trim().toLocaleLowerCase();let count=0;scope.querySelectorAll('[data-bl-producer-card]').forEach(card=>{card.hidden=!card.dataset.name.includes(q);if(!card.hidden)count++});scope.querySelector('[data-bl-producer-empty]').hidden=count>0});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl2-product"]) return;
  try {
    
document.addEventListener('click',function(e){
  var t=e.target.closest('[data-blpd-thumb]'); if(t){var img=document.querySelector('.blpd-main-art img'); if(img){img.src=t.dataset.src;document.querySelectorAll('[data-blpd-thumb]').forEach(function(x){x.classList.remove('is-active')});t.classList.add('is-active')}}
  var v=e.target.closest('[data-blpd-variant]'); if(v){document.querySelectorAll('.blpd-variant-option').forEach(function(x){x.classList.remove('is-active')});v.closest('.blpd-variant-option').classList.add('is-active');var p=document.querySelector('[data-blpd-price]');if(p)p.textContent=v.dataset.price}
});

  } catch(e) { console.error(e); }
})();
})();
